import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/warehouse/id-types")({
  component: () => (
    <Breadcrumb label="ID Types" to="/warehouse/id-types">
      <Outlet />
    </Breadcrumb>
  ),
});
